import '../assets/css/_variables.scss'; // Import the CSS file

export const CODE_2FA_MIN_LENGTH = 6;
export const PASSWORD_MIN_CHAR = 10;
export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{10,}$/;

export const REFRESH_TOKEN = "refresh_token";

export const DELETE_CONFIRMATION: any = {
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "var(--primary)",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
}

export const CHANGE_CONFIRMATION: any = {
    title: "Please confirm",
    text: "Are you sure to change the status of user?",
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "var(--primary)",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes",
    cancelButtonText: "No",
}

export const ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/jpg'];
export const MAX_FILE_SIZE_IN_BYTES = 1024 * 1024 * 2; // 1MB
export const MAX_FILE_SIZE_RESOLVED_IN_BYTES = 1024 * 1024 * 5; // 1MB


export const GLOBAL_DEFAULT = {
    CURRENT_PAGE: 1,
    LOADER_STATE: false,
    MODAL_STATE: false,
    PAGINATOR_ROWS: 10,
    PAGINATOR_FIRST: 0,
    SEARCH_STATE: "",
    SORT_FIELD: '_id',
    SORT_ORDER: 'DESC',
    ROW_PER_PAGE: 10,
    HIDE_TABLE_PAGINATOR: true,
    CUSTOM_PAGINATOR_VALUES: [10, 20, 50, 100]
}

export const COUNTRY_CALLING_CODES: any = [
    { label: "US (+1)", value: "+1" , code: "US"},
    { label: "CA (+1)", value: "+1" , code: "CA"},
    { label: "AU (+61)", value: "+61" , code: "AU"},
    { label: "SG (+65)", value: "+65" , code: "SG"},
    { label: "IN (+91)", value: "+91", code: "IN" },
    { label: "UA (+971)", value: "+971" , code: "UA"}
];  

export const ALLOWED_COUNTRIES: string[] = ['AU', 'SG', 'AE', 'US', 'CA', 'IN'];

export const VERIFICATION_HEADER = "Your account is in the process of being verified.";
export const VERIFICATION_MESSAGE = "Please note that account verification can take up to 72 hours. ";
export const VERIFICATION_MESSAGE2 = "Please contact support if verification is still pending after 3 business days.";
export const OTP_REQUEST_STATUS = {
    yes: 'YES',
    no: 'NO'
}